import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';

const Wineries = () => {
  const data = useStaticQuery(graphql`
    query {
      williamChris: file(
        relativePath: { eq: "wineries/williamChrisVineyards.png" }
      ) {
        ...wineryLogoFragment
      }
      quailsGate: file(relativePath: { eq: "wineries/quailsGate.jpg" }) {
        ...wineryLogoFragment
      }
      seppeltsfieldBarossa: file(
        relativePath: { eq: "wineries/seppeltsfield.jpg" }
      ) {
        ...wineryLogoFragment
      }
      paulCluver: file(relativePath: { eq: "wineries/paulCluver.jpg" }) {
        ...wineryLogoFragment
      }
      furleighEstate: file(
        relativePath: { eq: "wineries/furleighEstate.jpg" }
      ) {
        ...wineryLogoFragment
      }
      site {
        siteMetadata {
          totalWineries
        }
      }
    }
  `);

  return (
    <>
      <Title>
        Powering over {data.site.siteMetadata.totalWineries} wineries around the
        world
      </Title>
      <WineryWrapper>
        <Winery>
          <a
            href="https://www.williamchriswines.com/"
            target="_blank"
            rel="noreferrer"
            title="William Chris Vineyards."
          >
            <GatsbyImage
              image={data.williamChris.childImageSharp.gatsbyImageData}
              alt="William Chris Vineyards."
            />
          </a>
        </Winery>
        <Winery>
          <a
            href="https://www.quailsgate.com/"
            target="_blank"
            rel="noreferrer"
            title="Quails Gate Okanagan Valley."
          >
            <GatsbyImage
              image={data.quailsGate.childImageSharp.gatsbyImageData}
              alt="Quails Gate Okanagan Valley."
            />
          </a>
        </Winery>
        <Winery>
          <a
            href="https://seppeltsfield.com.au/"
            target="_blank"
            rel="noreferrer"
            title="Seppeltsfield Barossa."
          >
            <GatsbyImage
              image={data.seppeltsfieldBarossa.childImageSharp.gatsbyImageData}
              alt="Seppeltsfield Barossa."
            />
          </a>
        </Winery>
        <Winery>
          <a
            href="https://www.cluver.com/"
            target="_blank"
            rel="noreferrer"
            title="Paul Cluver Wines."
          >
            <GatsbyImage
              image={data.paulCluver.childImageSharp.gatsbyImageData}
              alt="Paul Cluver Wines."
            />
          </a>
        </Winery>
        <Winery>
          <a
            href="https://furleighestate.co.uk/"
            target="_blank"
            rel="noreferrer"
            title="Furleigh Estate Winery."
          >
            <GatsbyImage
              image={data.furleighEstate.childImageSharp.gatsbyImageData}
              alt="Furleigh Estate Winery."
            />
          </a>
        </Winery>
      </WineryWrapper>
    </>
  );
};

const Title = styled.h2`
  color: var(--gray-dark);
  font-size: var(--font-size-lg);
  letter-spacing: var(--letter-spacing-base);

  margin-bottom: 60px;
  text-align: center;
`;

const WineryWrapper = styled.ul`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1200px;
  margin: auto;
  ${({ theme }) => `
    @media ${theme.mediumUp} {
      justify-content: space-around;
    }
  `}
`;

const Winery = styled.li`
  width: 50%;
  margin-bottom: 30px;
  padding: 0 10px;

  a {
    display: block;
  }

  ${({ theme }) => `
    @media ${theme.mediumUp} {
      width: 33%;
    }
    @media ${theme.largeUp} {
      width: 20%;
    }
  `}

  img {
    width: 100%;
    max-width: 175px;
    max-height: 100px;
    margin: auto;
  }
`;

export default Wineries;
